import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import { galleryImages, eventImages } from '@/data/gallery';

function CarouselRow({ images }: { images: { src: string; alt: string }[] }) {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [
    Autoplay({ delay: 5000, stopOnInteraction: true }),
  ]);

  return (
    <div className="relative group mb-4">
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="flex">
          {images.map((img, i) => (
            <div
              key={i}
              className="flex-[0_0_50%] md:flex-[0_0_25%] min-w-0"
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-64 md:h-80 object-cover"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
      {/* Prev arrow */}
      <button
        className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/40 text-white flex items-center justify-center hover:bg-black/60 transition-colors opacity-0 group-hover:opacity-100"
        onClick={() => emblaApi?.scrollPrev()}
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      {/* Next arrow */}
      <button
        className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/40 text-white flex items-center justify-center hover:bg-black/60 transition-colors opacity-0 group-hover:opacity-100"
        onClick={() => emblaApi?.scrollNext()}
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
}

export default function GalleryCarousel() {
  return (
    <section className="py-20 bg-warm-50">
      <div className="container-wide">
        <h2 className="text-center mb-12">Stagedoor Gallery</h2>
      </div>
      <CarouselRow images={galleryImages} />
      <CarouselRow images={eventImages} />
    </section>
  );
}
